import React, { Component } from 'react';

import Header from './Header';
import Footer from './Footer';
import Social from './Social';
import ProductImage from './ProductImage';
import PostSidebar from './PostSidebar';

class Project extends Component {
  constructor(props) {
    super(props);

    this.postPrint = this.postPrint.bind(this);

    this.state = {
      posts: []
    }
  }

  componentWillMount() {
    const path = this.props.url.match.params.projectid;
    const posts = this.props.postData;
    let postInfo = [];
    
    for (let postNumber in posts) {
      let post = posts[postNumber];
      if (post.slug === path) {
        postInfo.push(post);
      }
    }

    if(postInfo.length > 0) {
      this.setState({posts: postInfo});
    }  
  }

  shouldComponentUpdate(nextProps, nextState) {
    const path = nextProps.url.match.params.projectid;
    const posts = nextProps.postData;
    let postInfo = [];
    
    for (let postNumber in posts) {
      let post = posts[postNumber];
      if (post.slug === path) {
        postInfo.push(post);
      }
    }

    if(postInfo.length > 0) {
      this.setState({posts: postInfo});
      return true;
    } else {
      return false;
    }
  }

  postPrint() {
    const posts = this.state.posts;
    if (this.state.posts != undefined && this.state.posts.length >= 1) {
      return posts.map((post, index) => {
        return (
            <div key={index} className="row collapse expanded">
              <div className="small-6 medium-7 large-9 columns">
                <ProductImage imgData={post.id} />
              </div>
              <div className="small-6 medium-5 large-3 columns">
                <PostSidebar post={post} />
              </div>
            </div>
          )
      });
    }
  }

  render() {
    return (
      <div className="App">
          <Header />
            <div className="App__intro">
              {this.postPrint()}
            </div>
          <Footer type="light" />
      </div>
    )
  }
}

Project.propTypes = {
  
}

export default Project;


// WEBPACK FOOTER //
// ./src/components/Project.js